import { useState } from "react";
import { MessageCircle, Phone, X, CalendarCheck, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { telLink, whatsappLink, CLINIC } from "../data/site";

export const FloatingActions = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3" data-testid="floating-actions">
      <AnimatePresence>
        {open && (
          <>
            <motion.a
              href={telLink}
              data-testid="floating-call"
              initial={{ opacity: 0, y: 12, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 12, scale: 0.8 }}
              transition={{ delay: 0.05 }}
              className="flex items-center gap-2 rounded-full bg-dash-ink text-white pl-4 pr-5 py-3 shadow-xl"
            >
              <Phone className="h-5 w-5" />
              <span className="text-sm font-semibold">Call Now</span>
            </motion.a>
            <motion.div
              initial={{ opacity: 0, y: 12, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 12, scale: 0.8 }}
            >
              <Link
                to="/contact"
                data-testid="floating-book"
                className="flex items-center gap-2 rounded-full bg-dash-gold text-dash-ink pl-4 pr-5 py-3 shadow-xl"
              >
                <CalendarCheck className="h-5 w-5" />
                <span className="text-sm font-semibold">Book</span>
              </Link>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      <Link
        to="/contact?service=Home%20Visit%20Physiotherapy"
        data-testid="floating-home-visit"
        className="sm:hidden flex items-center gap-2 rounded-full bg-dash-ink text-white pl-4 pr-5 py-3 shadow-2xl shadow-dash-ink/30"
      >
        <Home className="h-5 w-5 text-dash-gold" />
        <span className="text-sm font-semibold">Book Home Visit</span>
      </Link>

      <a
        href={whatsappLink()}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="group relative flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3.5 shadow-2xl shadow-[#25D366]/30 hover:-translate-y-0.5 transition-transform duration-300"
      >
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" style={{ animationDuration: "2.5s" }} />
        <MessageCircle className="relative h-6 w-6" />
        <span className="relative text-sm font-semibold hidden sm:inline">WhatsApp Us</span>
      </a>

      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="More contact options"
        data-testid="floating-toggle"
        className="h-11 w-11 rounded-full bg-white text-dash-ink shadow-lg border border-dash-line inline-flex items-center justify-center"
      >
        {open ? <X className="h-5 w-5" /> : <Phone className="h-5 w-5" />}
      </button>
    </div>
  );
};
